import type { ApiError } from '../api/client';

export function SaveBar({
  dirty,
  saving,
  error,
  onSave,
  onReset,
}: {
  dirty: boolean;
  saving: boolean;
  error?: unknown;
  onSave: () => void;
  onReset: () => void;
}) {
  const apiError = error as ApiError | undefined;
  return (
    <div className={dirty ? 'savebar active' : 'savebar'}>
      <span className="savebar-status">
        {saving
          ? 'Saving…'
          : dirty
            ? 'Unsaved changes'
            : 'All changes saved'}
      </span>
      {apiError ? (
        <span className="field-error" role="alert">
          {apiError.message}
        </span>
      ) : null}
      <div className="savebar-actions">
        <button type="button" className="btn subtle" disabled={!dirty || saving} onClick={onReset}>
          Discard
        </button>
        <button type="button" className="btn primary" disabled={!dirty || saving} onClick={onSave}>
          Save
        </button>
      </div>
    </div>
  );
}
